import { render } from "./CreatePolicy.vue?vue&type=template&id=5982699a"
import script from "./CreatePolicy.vue?vue&type=script&lang=js"
export * from "./CreatePolicy.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__